/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_NetworkInputs */

const en_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network`)
};

const zh_hans1_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网络`)
};

const pt_br2_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rede`)
};

const es_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red`)
};

const fr_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réseau`)
};

const de_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Netzwerk`)
};

const ru_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сеть`)
};

const it_nav_network = /** @type {(inputs: Nav_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rete`)
};

/**
* | output |
* | --- |
* | "Network" |
*
* @param {Nav_NetworkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_network = /** @type {((inputs?: Nav_NetworkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_NetworkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_network(inputs)
	if (locale === "pt-BR") return pt_br2_nav_network(inputs)
	if (locale === "es") return es_nav_network(inputs)
	if (locale === "fr") return fr_nav_network(inputs)
	if (locale === "de") return de_nav_network(inputs)
	if (locale === "ru") return ru_nav_network(inputs)
	if (locale === "it") return it_nav_network(inputs)
	return en_nav_network(inputs)
});